const fontFamily = [
	"sofia-pro",
	"sans-serif"
]

export default fontFamily.join(",")